var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWmoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 9.16682C6.33398 9.81349 6.83399 10.3335 7.44733 10.3335H8.70064C9.23398 10.3335 9.66732 9.88015 9.66732 9.31349C9.66732 8.70682 9.40066 8.48682 9.00732 8.34682L7.00065 7.64682C6.60732 7.50682 6.34066 7.29349 6.34066 6.68016C6.34066 6.12016 6.77398 5.66016 7.30731 5.66016H8.56065C9.17398 5.66016 9.67399 6.18016 9.67399 6.82682",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.00065C14.6673 11.6807 11.6807 14.6673 8.00065 14.6673C4.32065 14.6673 1.33398 11.6807 1.33398 8.00065C1.33398 4.32065 4.32065 1.33398 8.00065 1.33398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 2V4.66667H14.0007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 1.33398L11.334 4.66732",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmoneyRecive);
export default __webpack_public_path__ + "static/media/wmoney-recive.da9102640b555ec54a1195c857822f3c.svg";
export { ForwardRef as ReactComponent };